import { en, type TranslationKey } from "./en.ts";
import { th } from "./th.ts";

export type Locale = "en" | "th";
export type TranslationParams = Record<string, string | number>;
export const LOCALE_STORAGE_KEY = "smart-market.mm.locale.v1";

export interface LocaleStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export function localeTag(locale: Locale): string {
  return locale === "th" ? "th-TH" : "en-US";
}

export function normalizeLocale(value: unknown): Locale {
  return value === "th" || value === "en" ? value : "en";
}

export function readStoredLocale(storage: LocaleStorage): Locale {
  return normalizeLocale(storage.getItem(LOCALE_STORAGE_KEY));
}

export function writeStoredLocale(storage: LocaleStorage, locale: Locale): void {
  storage.setItem(LOCALE_STORAGE_KEY, locale);
}

export function interpolate(template: string, params?: TranslationParams): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (match, name: string) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match,
  );
}

export function translateWithResources(
  locale: Locale,
  key: TranslationKey,
  params?: TranslationParams,
  thaiResource: Partial<Record<TranslationKey, string>> = th,
): string {
  const localized = locale === "th" ? thaiResource[key] : undefined;
  return interpolate(localized ?? en[key], params);
}
